import { render, staticRenderFns } from "./Sio-Bottom.vue?vue&type=template&id=2e5d0a5f&"
import script from "./Sio-Bottom.vue?vue&type=script&lang=js&"
export * from "./Sio-Bottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports